import React, { useContext } from 'react';
import { breakpointColumns } from 'theming/grid';
import { useBreakpoint } from 'theming/hooks/useBreakpoint';
import { getColumnSize } from './Grid.utils';
import { GridContext, GridContextProvider } from './GridContext';
import * as S from './Grid.styles';
const RowContainer = /*#__PURE__*/React.forwardRef(({
  children,
  columnWidth
}, ref) => {
  const breakpoint = useBreakpoint();
  return /*#__PURE__*/React.createElement(GridContextProvider, {
    columnWidth: columnWidth
  }, /*#__PURE__*/React.createElement(S.RowContainerWrapper, {
    ref: ref,
    $breakpoint: breakpoint
  }, children));
});
const Row = /*#__PURE__*/React.forwardRef(({
  children,
  columnWidth
}, ref) => {
  const ctx = useContext(GridContext);
  const breakpoint = useBreakpoint(ctx.breakpoint);
  return /*#__PURE__*/React.createElement(GridContextProvider, {
    columnWidth: columnWidth ?? ctx?.defaultColumnWidth
  }, /*#__PURE__*/React.createElement(S.GridRow, {
    ref: ref,
    $breakpoint: breakpoint
  }, children));
});
const Column = /*#__PURE__*/React.forwardRef(({
  children,
  width
}, ref) => {
  const {
    breakpoint,
    defaultColumnWidth
  } = useContext(GridContext);
  const cellBaseWidth = 100 / breakpointColumns[breakpoint ?? 'mobile'];
  const columnSize = getColumnSize(width ?? defaultColumnWidth, breakpoint);
  const columnWidth = Math.min(cellBaseWidth * columnSize, 100);
  return /*#__PURE__*/React.createElement(S.GridColumn, {
    ref: ref,
    $breakpoint: breakpoint,
    $columnWidth: columnWidth
  }, children);
});
export { RowContainer, Row, Column };